import { createFileRoute } from "@tanstack/react-router";

import { AdminUsersScreen } from "@/features/admin/screens/AdminUsers";

export const Route = createFileRoute("/_authenticated/(admin)/admin/users")({
  component: AdminUsersScreen,
});
